import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { Capacitor } from "@capacitor/core";
import { getAuthApiBase } from "../utils/getApiBase";

export default function ActivateScreen() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const API = getAuthApiBase();

  const activate = async () => {
    setLoading(true);
    const token = localStorage.getItem("access_token");

    // console.log("🔑 [ACTIVATE] Token from storage:", token);
    // console.log("🌍 [ACTIVATE] API Base:", API);
    // console.log("➡️ [ACTIVATE] Hitting URL:", `${API}/products/access-recipe-tool/`);

    try {
        const res = await fetch(`${API}/products/access-recipe-tool/`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`,
        },
        });

        // console.log("📬 [ACTIVATE] Raw response object:", res);

        let text = await res.text();
        // console.log("📦 [ACTIVATE] Raw response text:", text);

        // Try parsing JSON safely
        let data = {};
        try {
        data = JSON.parse(text);
        // console.log("📦 [ACTIVATE] Parsed JSON:", data);
        } catch (jsonErr) {
        console.error("❌ [ACTIVATE] Failed to parse JSON", jsonErr);
        throw new Error("INVALID_JSON");
        }

        // Response code check
        // console.log("📡 [ACTIVATE] Status code:", res.status);

        if (!res.ok) {
        console.error("❌ [ACTIVATE] res.ok is FALSE");
        throw new Error("BAD_STATUS");
        }

        if (!data.redirect_url) {
        console.error("❌ [ACTIVATE] redirect_url missing");
        throw new Error("NO_REDIRECT_URL");
        }

      //  console.log("🚀 [ACTIVATE] Redirecting user to:", data.redirect_url);
        // In the Android app, a full-URL redirect leaves the WebView and opens Chrome.
        // Stay in-app by handing the token to the /login route (same handler the web uses).
        if (Capacitor.isNativePlatform()) {
          try {
            const target = new URL(data.redirect_url, window.location.origin);
            const urlToken = target.searchParams.get("token") || target.searchParams.get("access_token");
            if (urlToken) {
              const next = target.searchParams.get("next");
              const nextQs = next && next.startsWith("/") ? `&next=${encodeURIComponent(next)}` : "";
              navigate(`/login?token=${encodeURIComponent(urlToken)}${nextQs}`, { replace: true });
              return;
            }
          } catch (e) {
            console.warn("[ACTIVATE] Could not parse redirect_url, using default redirect", e);
          }
        }
        window.location.href = data.redirect_url;
    } catch (err) {
        console.error("🔥 [ACTIVATE ERROR] Activation exception:", err);
        alert("Activation failed.");
        setLoading(false);
    }
    };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-cream-color px-6">
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 border border-light-gray text-center">
        <div className="flex items-center justify-center mb-3">
          <CheckCircleIcon className="w-8 h-8 text-rich-gold mr-2" />
          <h1 className="text-2xl font-primary text-charcoal">
            You're All Set
          </h1>
        </div>

        <p className="text-charcoal text-sm font-forms mb-6">
          Your Ruoth account has been created successfully.  
          Tap the button below to enter your Recipe Tool.
        </p>

        <button
          onClick={activate}
          className="w-full bg-rich-gold text-white py-3 rounded-md font-action text-sm hover:bg-amber-600 transition"
        >
          {loading ? "Loading…" : "Enter Recipe Tool"}
        </button>

        <p
          className="mt-5 text-sm underline text-charcoal cursor-pointer"
          onClick={() => navigate("/login")}
        >
          Not you? Switch account
        </p>
      </div>
    </div>
  );
}